import React from 'react';
import { ProposalNav } from './components/ProposalNav';
import { ProposalHero } from './components/ProposalHero';
import { OverviewSection } from './components/OverviewSection';
import { BudgetAllocation } from './components/BudgetAllocation';
import { KeywordTable } from './components/KeywordTable';
import { GeoTargeting } from './components/GeoTargeting';
import { PerformanceProjections } from './components/PerformanceProjections';
import { TrackingTimeline } from './components/TrackingTimeline';
import { ProposalCTA } from './components/ProposalCTA';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <ProposalNav data-id="element-1" />
      <ProposalHero data-id="element-2" />
      <OverviewSection data-id="element-3" />
      <BudgetAllocation data-id="element-4" />
      <KeywordTable data-id="element-5" />
      <GeoTargeting data-id="element-6" />
      <PerformanceProjections data-id="element-7" />
      <TrackingTimeline data-id="element-8" />
      <ProposalCTA data-id="element-9" />
    </div>;
}